import React, { useState } from 'react';
import {
    IconButton,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Divider,
} from '@mui/material';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const StyledMenu = styled(Menu)(({ theme }) => ({
    '& .MuiPaper-root': {
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
        borderRadius: 6,
        minWidth: 180,
    },
}));

const StyledMenuItem = styled(MenuItem)(({ theme, danger }) => ({
    fontSize: '0.875rem',
    padding: '8px 16px',

    ...(danger && {
        color: theme.palette.error.main,

        '& .MuiListItemIcon-root': {
            color: theme.palette.error.main,
        },
    }),
}));

const LsActionMenu = ({ actions = [], icon, ...props }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAction = (action) => {
        action.onClick?.();
        handleClose();
    };

    return (
        <>
            <IconButton
                size="small"
                onClick={handleClick}
                aria-label="more actions"
                {...props}
            >
                {icon || <MoreVertIcon fontSize="small" />}
            </IconButton>
            <StyledMenu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {actions.map((action, index) => (
                    <React.Fragment key={index}>
                        {action.divider ? (
                            <Divider />
                        ) : (
                            <StyledMenuItem
                                onClick={() => handleAction(action)}
                                danger={action.danger}
                                disabled={action.disabled}
                            >
                                {action.icon && (
                                    <ListItemIcon sx={{ minWidth: 36 }}>
                                        {action.icon}
                                    </ListItemIcon>
                                )}
                                <ListItemText>{action.label}</ListItemText>
                            </StyledMenuItem>
                        )}
                    </React.Fragment>
                ))}
            </StyledMenu>
        </>
    );
};

export default LsActionMenu;